module.exports = __webpack_public_path__ + "static/media/background.7538742c.jpg";